// This file can be replaced during build by using the `fileReplacements` array.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  environmentName: 'dev',
  mainServiceUrl: 'https://dev.api.gvgolfclub.com/',
  pgaEmail: 'membership@pgaofcanada.com',
  pgaSiteUrl: 'pgaofcanada.com',
  internalSiteUrl: 'http://localhost:4200/',
  memberSiteUrl: 'http://localhost:4201/',
};
